export const booksItems = [
        {
            index: 'B03',
            text: 'A. El Saddik, S. Hossain, B. Kantarci, " Connected Health in Smart Cities", Springer, , ISBN 978-3-030-27844-1, 2020,',
            doi: 'https://doi.org/10.1007/978-3-030-27844-1',
            bib: '@book{el2020connected,\n  title={Connected health in smart cities},\n  author={El Saddik, Abdulmotaleb and Hossain, M Shamim and Kantarci, Burak},\n  year={2020},\n  publisher={Springer}}'
        },
        {
            index: 'B02',
            text: 'B. Kantarci and S. Oktug, "Wireless Sensor and Actuator Networks for Smart Cities, MDPI JSAN, ISBN 978-3-03897-423-9, (paperback); ISBN 978-3-03897-424-6 (PDF), Dec. 2018. DOI: 10.3390/books978-3-03897-424-6, ',
            doi: 'https://doi.org/10.3390/books978-3-03897-424-6',
            bib: '@misc{kantarci2018wireless,\n  title={Wireless sensor and actuator networks for smart cities},\n  author={Kantarci, Burak and Oktug, Sema F},\n  journal={Journal of Sensor and actuator Networks},\n  volume={7},\n  number={4},\n  pages={49},\n  year={2018},\n  publisher={MDPI}}'
        },
        {
            index: 'B01',
            text: 'H. T. Mouftah and B. Kantarci, "Communication Infrastructures for Cloud Computing", IGI Global, Hershey, Pennsylvania, USA, September 2013, ISBN13: 9781466645226, ',
            doi: 'https://doi.org/10.4018/978-1-4666-4522-6',
            bib: '@book{mouftah2013communication,\n  title={Communication Infrastructures for Cloud Computing},\n  author={Mouftah, Hussein T and Kantarci, Burak},\n  year={2013},\n  publisher={IGI Global}\n}'
        },

    ];